<template>
  <div class="pic-package-desc">
    <h3>图片包描述</h3>
    <div class="price-desc">
      <i class="icon_dollar">￥</i>
      <span class="pic-price">{{ detail.package_price }}</span>
      <span class="pic-num">/ {{ detail.pic_num - 1 }}张</span>
    </div>
    <div class="pic-desc"> {{ detail.package_content }}</div>
  </div>
</template>

<script>
export default {
  name: "TuPianDetailsPicPackageDesc",
  props: {
    detail: {
      type: Object,
      default: () => {
      }
    }
  },
  data() {
    return {
    }
  },
}
</script>

<style lang="scss" scoped>
.pic-package-desc {
  h3 {
    font-size: 28px;
    font-weight: bold;
    color: #0A2540;
    line-height: 37px;
    letter-spacing: 1px;
  }

  .price-desc {
    margin: 4px 0 12px;
    font-size: 0;
    color: #6969FF;

    .icon_dollar {
      display: inline-block;
      font-size: 18px;
      font-weight: bold;
      line-height: 24px;
    }

    .pic-price {
      display: inline-block;
      font-size: 30px;
      font-weight: bold;
      line-height: 40px;
      margin: 0 2px 0 4px;
    }

    .pic-num {
      display: inline-block;
      font-size: 13px;
      line-height: 17px;
    }
  }

  .pic-desc {
    font-size: 14px;
    color: rgba(0, 16, 19, 0.75);
    line-height: 22px;
  }
}
</style>
